module.exports = __webpack_public_path__ + "img/mainPicture.2d6e981b.png";